var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-4",attrs:{"icon":""},on:{"click":_vm.switchShowMode}},[_c('v-icon',[_vm._v("mdi-brightness-4")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }